/**
 * GeolocateController
 * 
 * @Author: Focci
 * @Date: 2023-07-13 17:39:42
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-13 17:39:42
 */

import { useMapState } from '@comp/mapbox'
import useTracking from '@hook/useTracking'
import nonSatelliteImg from '@img/mapbox-icon-normal.png'
import satelliteImg from '@img/mapbox-icon-satellite.png'
import { houseToGta, isAU } from '@lib/utils'
import Image from 'next/image'
import PropTypes from 'prop-types'
import ControllerWrapper from './ControllerWrapper'

function SingleGeolocateController({
  small = false,
  satellite = false,
  ...props
}) {
  const mapboxState = useMapState()
  const url = satellite ? satelliteImg : nonSatelliteImg
  const imgSize = small ? 50 : 80
  return (
    <ControllerWrapper
      small={small}
      onClick={() => mapboxState.setSatellite(!mapboxState.satellite)}
      {...props}
    >
      <Image
        priority
        src={url || ''}
        width={imgSize}
        height={imgSize}
        alt="Geolocate"
        unoptimized
      />
    </ControllerWrapper>
  )
}

export default function GeolocateController({
  small = false,
  single = false,
  className,
  house
}) {
  const mapboxState = useMapState()

  const { pushTrack } = useTracking()
  function handleClick() {
    mapboxState.setSatellite(!mapboxState.satellite)
    if (!mapboxState.satellite && isAU) {
      pushTrack('homely_street_view_interaction', houseToGta(house))
    }
  }

  if (single) {
    return <SingleGeolocateController
      small={small}
      className={className}
      satellite={!mapboxState.satellite}
      onClick={handleClick}
    />
  }

  return (
    <>
      <SingleGeolocateController
        small={small}
        className={className}
        satellite={true}
        onClick={() => mapboxState.setSatellite(true)}
        isSelected={mapboxState.satellite}
      />
      <SingleGeolocateController
        small={small}
        className={className}
        satellite={false}
        onClick={() => mapboxState.setSatellite(false)}
        isSelected={!mapboxState.satellite}
      />
    </>
  )
}

GeolocateController.propTypes = {
  small: PropTypes.bool,
  single: PropTypes.bool,
}
